import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const XRGB: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#002677}'}</style>
    <g id="Layer_1">
      <path
        d="M8.46728 3.98733L27.9867 23.5065C29.231 24.7507 29.2311 26.7681 27.9868 28.0123C26.7425 29.2566 24.7252 29.2567 23.481 28.0124L3.96155 8.49313C1.95442 6.48607 3.37595 3.0542 6.21442 3.0542C7.05942 3.0542 7.86982 3.38987 8.46728 3.98733Z"
        fill="#002677"
      />
      <path
        d="M23.5291 3.93313L3.90101 23.5609C2.65674 24.8052 2.65667 26.8225 3.90094 28.0668C5.14521 29.3111 7.16254 29.3111 8.40681 28.0669L28.0348 8.439C30.042 6.43187 28.6205 3 25.782 3C24.937 3 24.1266 3.33567 23.5291 3.93313Z"
        fill="#FF612B"
      />
    </g>
  </Box>
)
export default XRGB
